import React, { useState } from "react";
import "./navbaradmin.css";
import { Link } from 'react-router-dom';


const Navbaradmin = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [aboutusMenuOpen, setAboutusMenuOpen] = useState(false);
  const [admissionsMenuOpen, setAdmissionsMenuOpen] = useState(false);

  const loc = window.location;
  const baseUrl = `${loc.protocol}//${loc.hostname}${loc.hostname === 'localhost' ? ':5000' : ''}`;
  const dynamicpart = '/librarylogOut';
  const fullUrl = baseUrl + dynamicpart;

  ///const dynamiclogout = '/logoutactive';
  ///const fullUrllogout = baseUrl + dynamiclogout;


  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const toggleAboutusMenu = () => {
    setAboutusMenuOpen(!aboutusMenuOpen);
    //setAdmissionsMenuOpen(false);
  };

  const toggleAdmissionsMenu = () => {
    setAdmissionsMenuOpen(!admissionsMenuOpen);
    setAboutusMenuOpen(false);
  };


  const handleClick = () => {
      window.scrollTo(0, 0); // Scroll to the top
  };



  const removetoken = () => {

    const fetchContents = async () => {
      await fetch(fullUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      })
        .then(response => response.json())
        .then(data => {
          console.log("data contents log",data)
  
      });
      
    };

    fetchContents();

  }


  return (
    <>  
      
      <div className="navsectionmAdmin">
        <div className="schoollogonameAdmin">
            <img src="data:image/jpeg;base64,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" alt="masiyempambililogo" />
        </div>
        <img className="masiyefullnameAdmin" src="https://ucarecdn.com/e0d57abf-6863-424a-a666-fd42d6508cae/-/preview/400x50/" alt="masiyephambilijunior" />
        <nav className="navbarmainAdmin">
            <div className="navbar-containerAdmin">
                
                <ul className={`navlistAdmin ${showMenu ? 'show-menuAdmin' : ''}`}>
                    <div className={`close-iconAdmin ${showMenu ? 'show-iconAdmin' : ''}`} onClick={toggleMenu}>
                        &times;
                    </div>
                    <Link
                        to = "/libraydashadh1"
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li>
                      <p>Dashboard</p>
                    </li>
                    </Link>
                     <Link
                        to = "/staffattendance"
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li>
                      <p>Attendance</p>
                    </li>
                    </Link>
                    <li className="dropdownAdmin" onClick={toggleAboutusMenu}>
                        <p>Leave &#9662;</p>
                        {aboutusMenuOpen &&
                        <div className="dropdownAdmin-content">
                            <Link
                              to = "/leaveapplications"
                              onClick={handleClick}
                              style={{ textDecoration: 'none', color: 'black', padding: 0}}
                            >
                            <p>Leave Applications</p>
                            </Link>
                            <Link
                              to = "/leavedays"
                              onClick={handleClick}
                              state = {{
                                data: { majorevents: "all", abt: "" }  //accounts employeedemographics your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                              }}
                              style={{ textDecoration: 'none', color: 'black', padding: 0}}
                            >
                            <p>Leave Days</p>
                            </Link>  
                            <Link
                              to = "/employeedemographics"
                              onClick={handleClick}
                              state = {{
                                data: { majorevents: "all", abt: "" }  // leavehistory your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                              }}
                              style={{ textDecoration: 'none', color: 'black', padding: 0}}
                            >
                            <p>Demographics</p>
                            </Link>  
                            <Link
                              to = "/leavehistory"
                              onClick={handleClick}
                              state = {{
                                data: { majorevents: "all", abt: "" }  // leavecalendar leavehistory your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                              }}
                              style={{ textDecoration: 'none', color: 'black', padding: 0}}
                            >
                            <p>History</p>
                            </Link>
                            <Link
                              to = "/leavecalendar"
                              onClick={handleClick}
                              state = {{
                                data: { majorevents: "all", abt: "" }  //  leavehistory your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                              }}
                              style={{ textDecoration: 'none', color: 'black', padding: 0}}
                            >
                            <p>Calendar</p>
                            </Link>
                            
                        </div>
                        }
                    </li>
                    <Link
                        to = "/invoices"
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Invoices</p></li>
                    </Link>
                     <Link
                        to = "/accounts"
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Accounts</p></li>
                    </Link>
                    <Link
                        to = "/classattendance"
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Class Attendance</p></li>
                    </Link>
                    <Link
                        to = "/studentreportcard"
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Report Card</p></li>
                    </Link>
                     <Link
                        to = "/clockin" 
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                      >
                        <li><p>Clock in</p></li>
                      </Link>
                   
 
                    
                     <Link
                      to = "/"

                      onClick={removetoken}

                      style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                      <li><p>Log Out</p></li>
                    </Link>
                </ul>
                <div className={`menu-iconAdmin ${showMenu ? 'hide-iconAdmin' : ''}`} onClick={toggleMenu}>
                &#9776;
                </div>
            </div>
        </nav>
      </div>
    </>
  );
};

export default Navbaradmin;



/*
<li className="dropdownAdmin" onClick={toggleAdmissionsMenu}>
                        <p>Leave Days &#9662;</p>
                        {admissionsMenuOpen &&
                        <div className="dropdownAdmin-content">
                        <Link
                          to = "/leaveform"
                          onClick={handleClick}
                          style={{ textDecoration: 'none', color: 'black', padding: 0}}
                        >
                        <p>Leave Form</p>
                        </Link>
                        <Link
                          to = "/clubs"
                          onClick={handleClick}
                          state = {{
                            data: { club: "all" }  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                          }}
                          style={{ textDecoration: 'none', color: 'black', padding: 0}}
                        >
                        <p>Annual days Leave</p>
                        </Link>
                        </div>
                        }
                    </li>
                    */


